import { Component, Input, OnInit } from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import {
    DocumentViewerCategoryItem,
    DocumentViewerData,
    DocumentViewerItem,
    ViewerData
} from 'src/app/models/DocumentViewer.model';
import {
    ApiResult,
} from 'src/app/models/PromiseResult';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
    selector: 'app-document-viewer',
    templateUrl: './document-viewer.component.html',
    styleUrls: ['./document-viewer.component.css']
})
@TraceClassDecorator()
export class DocumentViewerComponent implements OnInit {
    @Input('data')
    api_result: ApiResult = new ApiResult(true);

    documentViewer: DocumentViewerData = {
        data: {
            input: {
                documents: {}
            },
            viewerData: this.init_viewerData()
        }
        // others: {

        // }
    };

    constructor(private readonly utilitiesService: UtilitiesService) {}

    async ngOnInit(): Promise<void> {
        this.documentViewer.data.input.documents =
            this.api_result.PromiseResult.data;
        await this.set_viewerData();
    }

    shallow_copy(a): any {
        return this.utilitiesService.shallow_copy(a);
    }

    get_categories(): string[] {
        return Object.keys(this.documentViewer.data.input.documents);
    }

    init_DocumentViewerItem(): DocumentViewerItem {
        let a: DocumentViewerItem = {
            file_id: -1,
            document_link: '',
            document_name: '',
            document_size: '',
            document_type: '',
            encoded_uri: '',
            image_container: '',
            is_pdf: null,
            id: -1,
            name: '',
            updated_at: ''
        };
        return a;
    }

    init_viewerData(): ViewerData {
        let viewerData: ViewerData = {
            data: [],
            current_index: 0,
            current_file_data: this.init_DocumentViewerItem(),
            is_visible: false
        };
        return viewerData;
    }

    get_viewerCategoryAllData() {
        let data: DocumentViewerCategoryItem[] = [];
        let categories_list: string[] = this.get_categories().map((ele) => {
            return ele;
        });
        let obj = this.shallow_copy(this.documentViewer.data.input.documents);

        categories_list.map((ele) => {
            if (obj.hasOwnProperty(ele)) {
                if (obj[ele].length > 0) {
                    let a: DocumentViewerCategoryItem = {
                        id: data.length,
                        name: ele.replace(/_/g, ' ').toUpperCase(),
                        file_data: obj[ele].map((ele, index) => {
                            let ele_new: DocumentViewerItem;
                            let r = this.shallow_copy(ele);
                            r['encoded_uri'] = encodeURI(r.document_link);
                            r['image_container'] = this.randomString(5);
                            r['id'] = index;
                            r['is_pdf'] = this.is_pdf(ele.document_name);
                            r['name'] =
                                'File ' +
                                Number(index + 1) +
                                '.' +
                                this.getExtension(ele.document_name);
                            ele_new = r;
                            return ele_new;
                        }),
                        current_index: 0
                    };
                    data.push(a);
                }
            }
        });
        return data;
    }

    async onFileChange(id: number, event: any, type: string) {
        if (type == 'category') {
            await this.changeFileData(
                this.documentViewer.data.viewerData.data[event.index].file_data[
                    id
                ]
            );
        } else if (type == 'file') {
            await this.changeFileData(
                this.documentViewer.data.viewerData.data[id].file_data[
                    event.index
                ]
            );
        }
    }

    async changeFileData(data: DocumentViewerItem) {
        this.documentViewer.data.viewerData.is_visible = false;
        this.documentViewer.data.viewerData.current_file_data =
            this.shallow_copy(data);
        setTimeout(() => {
            this.documentViewer.data.viewerData.is_visible = true;
        }, 1000);
    }

    async set_viewerData() {
        this.documentViewer.data.viewerData.is_visible = false;
        let viewerData: ViewerData = this.init_viewerData();
        viewerData = {
            data: await this.get_viewerCategoryAllData(),
            current_index: 0,
            current_file_data: this.init_DocumentViewerItem(),
            is_visible: false
        };

        viewerData.current_file_data =
            viewerData.data.length > 0
                ? viewerData.data[0].file_data.length > 0
                    ? viewerData.data[0].file_data[0]
                    : this.init_DocumentViewerItem()
                : this.init_DocumentViewerItem();

        this.documentViewer.data.viewerData = viewerData;

        setTimeout(() => {
            this.documentViewer.data.viewerData.is_visible = true;
        }, 1000);
    }

    getExtension(a: string): string {
        return this.utilitiesService.getExtension(a);
    }

    is_pdf(a: string): boolean {
        if (Boolean(a)) {
            return this.getExtension(a) == 'pdf';
        }
    }

    randomString(n: number): string {
        let res = '';
        let chars =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charLen = chars.length;

        for (var i = 0; i < n; i++) {
            res += chars.charAt(Math.floor(Math.random() * charLen));
        }
        return res;
    }

    async onNext() {
        let current_category_index: number =
            this.documentViewer.data.viewerData.current_index;
        let current_file_data_index: number =
            this.documentViewer.data.viewerData.data[current_category_index]
                .current_index;
        let max_current_file_data_index: number =
            this.documentViewer.data.viewerData.data[current_category_index]
                .file_data.length - 1;
        let min_current_file_data_index: number = 0;
        let a: boolean = Boolean(
            current_file_data_index < max_current_file_data_index
        );
        if (a) {
            this.documentViewer.data.viewerData.data[current_category_index]
                .current_index++;
            current_file_data_index =
                this.documentViewer.data.viewerData.data[current_category_index]
                    .current_index;
            await this.changeFileData(
                this.documentViewer.data.viewerData.data[current_category_index]
                    .file_data[current_file_data_index]
            );
        }
    }

    async onPrevious() {
        let current_category_index: number =
            this.documentViewer.data.viewerData.current_index;
        let current_file_data_index: number =
            this.documentViewer.data.viewerData.data[current_category_index]
                .current_index;
        let max_current_file_data_index: number =
            this.documentViewer.data.viewerData.data[current_category_index]
                .file_data.length - 1;
        let min_current_file_data_index: number = 0;
        let a: boolean = Boolean(
            current_file_data_index > min_current_file_data_index
        );
        if (a) {
            this.documentViewer.data.viewerData.data[current_category_index]
                .current_index--;
            current_file_data_index =
                this.documentViewer.data.viewerData.data[current_category_index]
                    .current_index;
            await this.changeFileData(
                this.documentViewer.data.viewerData.data[current_category_index]
                    .file_data[current_file_data_index]
            );
        }
    }

    isEmptyData(): boolean {
        return this.documentViewer.data.viewerData.data.length == 0;
    }
}
